var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useThemeConfig } from "../themeConfigContext";
import { SettingsSection } from "../../themeSettingsUtils";
import "../../themeSettings.css";
export function GridSection(_a) {
    var rows = _a.rows;
    var _b = useThemeConfig(), configs = _b.configs, units = _b.units, optionsFont = _b.optionsFont, updateSetting = _b.updateSetting, handlePaddingMarginChange = _b.handlePaddingMarginChange;
    return (_jsx("div", __assign({ className: "content" }, { children: rows.map(function (row, i) { return (_jsx("div", __assign({ className: "columns flex flex-wrap gap-4 mt-2 " }, { children: row.map(function (item, j) { return (_jsx(SettingsSection, __assign({ title: item.title, label: item.label, configs: configs, handlePaddingMarginChange: handlePaddingMarginChange, updateSetting: updateSetting, units: units, margin: item.margin, padding: item.padding, border: item.border, borderRadius: item.borderRadius, opacity: item.opacity, font: item.font, optionsFont: item.font ? optionsFont : undefined }, item.extraProps), j)); }) }), i)); }) })));
}
